import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { HardHat, Eye, EyeSlash, CheckCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function RedefinirSenha() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [s1, setS1] = useState("");
  const [s2, setS2] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [erro, setErro] = useState("");
  const [ok, setOk] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErro("");
    if (s1.length < 8) { setErro("A senha deve ter pelo menos 8 caracteres."); return; }
    if (s1 !== s2) { setErro("As senhas não conferem."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/fornecedor/redefinir-senha", { token, nova_senha: s1 });
      setOk(data.message);
    } catch (err) {
      const d = err?.response?.data?.detail;
      setErro(typeof d === "string" ? d : "Link inválido ou expirado. Solicite uma nova redefinição de senha.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B1220] text-[#E9EEF5] p-6" data-testid="redefinir-senha-page" translate="no">
      <div className="w-full max-w-md tce-card p-8 fade-up">
        <div className="flex items-center gap-3 mb-8">
          <HardHat weight="duotone" size={30} className="text-[#FFDF00]" />
          <div className="font-heading text-lg">Portal do Fornecedor</div>
        </div>
        {ok ? (
          <div data-testid="redefinir-ok" className="space-y-6">
            <div className="flex items-start gap-3 text-[#22C55E]"><CheckCircle size={22} weight="fill" /><span>{ok}</span></div>
            <Link to="/fornecedor/login" data-testid="redefinir-ir-login" className="block text-center w-full bg-[#009C3B] text-white font-medium py-3 rounded-md hover:bg-[#00B347]">Ir para o login</Link>
          </div>
        ) : !token ? (
          <div className="space-y-4">
            <p className="text-sm text-[#EF4444]" data-testid="redefinir-sem-token">Link inválido. Solicite uma nova redefinição na tela de login.</p>
            <Link to="/fornecedor/login" className="text-sm text-[#009C3B]">Voltar ao login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div>
              <h2 className="font-heading text-2xl tracking-tight">Criar nova senha</h2>
              <p className="text-sm text-[#94A3B8] mt-1">Mínimo de 8 caracteres.</p>
            </div>
            <div className="relative">
              <input data-testid="redefinir-senha1" type={show ? "text" : "password"} required value={s1} onChange={(e) => setS1(e.target.value)}
                     placeholder="Nova senha" className="tce-input w-full px-4 py-3 rounded-md pr-12" />
              <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#94A3B8]">
                {show ? <EyeSlash size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <input data-testid="redefinir-senha2" type={show ? "text" : "password"} required value={s2} onChange={(e) => setS2(e.target.value)}
                   placeholder="Confirme a nova senha" className="tce-input w-full px-4 py-3 rounded-md" />
            {erro && <div data-testid="redefinir-erro" className="text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/40 rounded-md px-3 py-2">{erro}</div>}
            <button data-testid="redefinir-submit" disabled={busy} className="w-full bg-[#009C3B] text-white font-medium py-3 rounded-md hover:bg-[#00B347] disabled:opacity-50">
              {busy ? "Salvando…" : "Salvar nova senha"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
